import { TagColor } from '@varo/graphql-schema-types';
import { TagType } from 'shared/components/vxl/Tag/Tag';
import vxlColors from 'shared/styles/color/core';

export type TrackerState = 'Locked' | 'Active' | 'Completed' | 'Failed';
export type StepState = 'current' | 'complete' | 'resting' | 'failed';

interface TrackerStyle {
  borderColor: string;
  color: string;
  tintColor: string;
}

export function getIntervalTrackerStyle(state: TrackerState): TrackerStyle {
  let borderColor: string;
  let color: string;
  let tintColor: string;

  switch (state) {
    case 'Locked':
      borderColor = vxlColors.core.neutrals.grey[200];
      color = vxlColors.core.neutrals.grey[400];
      tintColor = vxlColors.core.neutrals.white;
      break;
    case 'Active':
      borderColor = vxlColors.core.purple[900];
      color = vxlColors.core.neutrals.black;
      tintColor = vxlColors.core.neutrals.grey[100];
      break;
    case 'Completed':
      borderColor = vxlColors.core.neutrals.grey[200];
      color = vxlColors.core.neutrals.grey[400];
      tintColor = vxlColors.core.purple[500];
      break;
    case 'Failed':
      borderColor = vxlColors.core.neutrals.grey[200];
      color = vxlColors.core.neutrals.grey[400];
      tintColor = vxlColors.core.neutrals.grey[100];
      break;
    default:
      borderColor = '';
      color = '';
      tintColor = '';
  }

  return { borderColor, color, tintColor };
}

export const getTagType = (tagColor: TagColor | undefined) => {
  let tagType: TagType;

  switch (tagColor) {
    case TagColor.Info:
      tagType = TagType.INFO;
      break;
    case TagColor.Emphasized:
      tagType = TagType.INFO_EMPHASIZED;
      break;
    case TagColor.Highlight:
      tagType = TagType.HIGHLIGHT;
      break;
    case TagColor.Positive:
      tagType = TagType.SUCCESS;
      break;
    case TagColor.Negative:
      tagType = TagType.ERROR;
      break;
    case TagColor.Reverse:
      tagType = TagType.INFO_REVERSE;
      break;
    case TagColor.Warning:
      tagType = TagType.WARNING;
      break;
    default:
      tagType = TagType.INFO;
  }

  return tagType;
};
